import React from 'react';
import createReactContext from '../context';
var context = createReactContext({});
var Consumer = context.Consumer; // eslint-disable-next-line

export var Provider = context.Provider;
export var scrollConsumer = function scrollConsumer(Origin) {
  return function (props) {
    return (
      /*#__PURE__*/
      React.createElement(Consumer, null, function () {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, props, {
            scrollElement: value.element,
            scrollLeft: value.left,
            scrollTop: value.top
          }))
        );
      })
    );
  };
};